import { render } from "./company-sso-configuration.vue?vue&type=template&id=2e367d5d&ts=true"
import script from "./company-sso-configuration.vue?vue&type=script&lang=ts"
export * from "./company-sso-configuration.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__